var blockquote_default = {
  "fontElementMap": "I8IJq",
  "quote": "gZeHt"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
